<template>
  <div>
    <nav class="header-navbar navbar navbar-expand-lg align-items-center floating-nav navbar-light navbar-shadow">
      <div class="navbar-container d-flex content"
           style="background-color: #316992 !important;">
        <div class="bookmark-wrapper d-flex align-items-center">
          <ul class="nav navbar-nav d-xl-none">
            <li class="nav-item"><a class="nav-link menu-toggle" href="javascript:void(0);"><i class="ficon text-white"
                                                                                               data-feather="menu"></i></a>
            </li>
          </ul>
        </div>
        <ul class="nav navbar-nav align-items-center ml-auto">
          <li class="nav-item dropdown dropdown-language">
            <div class="col-12"><select
                class="form-control mr-1"
                v-model="selectdValet"
                id="basicSelect"
            >
              <option
                  :key="valetIndex"
                  :value="valet"
                  v-for="(valet, valetIndex) in valetData"
              >
                <span>{{ valet.currency.code }}</span>
                <div class="badge badge-light-success" v-if="valet.is_default ==2"> / RR</div>
              </option>
            </select></div>
          </li>
          <li class="nav-item dropdown dropdown-language">
            <div class="col-12">
              <button class="btn btn-gradient-success btn-sm" @click="showApiKeys = true">Api Keys</button>
            </div>
          </li>
          <li id="noti-dropdown-li" class="nav-item dropdown dropdown-notification mr-25" @click="getNotifications"><a class="nav-link"
                                                                                                 href="javascript:void(0);"
                                                                                                 data-toggle="dropdown"><i
              class="ficon text-white"
              data-feather="bell"></i><span
              class="badge badge-pill badge-danger badge-up">{{ notiCount }}</span></a>
            <ul class="dropdown-menu dropdown-menu-media dropdown-menu-right" id="noti-dropdown-ul">
              <li class="dropdown-menu-header">
                <div class="dropdown-header d-flex">
                  <h4 class="notification-title mb-0 mr-auto">Notifications</h4>
                </div>
              </li>
              <li class="scrollable-container media-list"><a class="d-flex" href="javascript:void(0)"></a>
                <div class="media d-flex align-items-center" v-if="notificationList.length">
                  <h6 class="font-weight-bolder mr-auto mb-0">System Notifications</h6>
                </div>
                <a class="d-flex mt-1" href="javascript:void(0)" v-if="!notificationList.length">
                  <div class="media justify-content-center">
                    <p>No Notifications</p>
                  </div>
                </a>
                <a class="d-flex" href="javascript:void(0)" v-for="(item,index) in notificationList" :key="index">
                  <div class="media d-flex align-items-start">
                    <div class="media-left">
                      <div class="avatar bg-light-warning">
                        <div class="avatar-content"><BIconBell /></div>
                      </div>
                    </div>
                    <div class="media-body" @click="routeTo(item.type)">
                      <p class="media-heading"><span class="font-weight-bolder">{{item.type}}</span>
                      </p><small
                        class="notification-text"> {{item.message}}</small>
                    </div>
                  </div>
                </a>
              </li>
              <li class="dropdown-menu-footer"><a class="btn btn-primary btn-block" href="javascript:void(0)" @click="$router.push({name:'all-notification'})">Read all
                notifications</a></li>
            </ul>
          </li>
          <li class="nav-item dropdown dropdown-user"><a class="nav-link dropdown-toggle dropdown-user-link"
                                                         id="dropdown-user" href="javascript:void(0);"
                                                         data-toggle="dropdown" aria-haspopup="true"
                                                         aria-expanded="false">
            <div class="user-nav d-sm-flex d-none"  v-if="isLoggedInByAdmin()">
              <span class="user-name font-weight-bolder text-white font-medium-1">
                Logged In By Admin
              </span>
<!--              <span class="user-status text-white">Merchant</span>-->
            </div>
            <div class="user-nav d-sm-flex d-none" v-else>
              <span class="user-name font-weight-bolder text-white">
                {{$store.getters.getLoggedInUser ? $store.getters.getLoggedInUser.first_name + ' ' + $store.getters.getLoggedInUser.last_name : '' }}
              </span>
              <span class="badge badge-pill badge-danger font-weight-bolder" v-if="$store.getters.isPayfacMerchant">PayFac</span>
              <span class="user-status text-white" v-else>Merchant</span>
            </div>
            <span class="avatar"><img class="round"
                                      :key="keyUpdate"
                                      :src="profileImage"
                                      alt="avatar" height="40" width="40"><span
                class="avatar-status-online"></span></span>
          </a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdown-user">
              <a v-if="!isLoggedInByAdmin()" class="dropdown-item" @click="$router.push({name: 'profile'})" href="javascript:void(0)"><i
                  class="mr-50" data-feather="user"></i> Profile</a>
<!--              <div class="dropdown-divider"></div>-->
              <a class="dropdown-item" @click="$router.push({name: 'app-setting'})" href="javascript:void(0)"><i
                  class="mr-50"
                  data-feather="settings"></i>
                Settings</a>
              <a class="dropdown-item" href="javascript:void(0)" @click="showLogoutModal = true"><i
                class="mr-50"
                data-feather="power"></i>
              Logout</a>
            </div>
          </li>
        </ul>
      </div>
    </nav>
<!--    <ul class="main-search-list-defaultlist d-none">-->
<!--      <li class="d-flex align-items-center"><a href="javascript:void(0);">-->
<!--        <h6 class="section-label mt-75 mb-0">Files</h6>-->
<!--      </a></li>-->
<!--      <li class="auto-suggestion"><a class="d-flex align-items-center justify-content-between w-100"-->
<!--                                     href="javascript:void(0)">-->
<!--        <div class="d-flex">-->
<!--          <div class="mr-75"><img src="app-assets/images/icons/xls.png" alt="png" height="32"></div>-->
<!--          <div class="search-data">-->
<!--            <p class="search-data-title mb-0">Two new item submitted</p><small class="text-muted">Marketing-->
<!--            Manager</small>-->
<!--          </div>-->
<!--        </div>-->
<!--        <small class="search-data-size mr-50 text-muted">&apos;17kb</small>-->
<!--      </a></li>-->
<!--      <li class="auto-suggestion"><a class="d-flex align-items-center justify-content-between w-100"-->
<!--                                     href="javascript:void(0)">-->
<!--        <div class="d-flex">-->
<!--          <div class="mr-75"><img src="app-assets/images/icons/jpg.png" alt="png" height="32"></div>-->
<!--          <div class="search-data">-->
<!--            <p class="search-data-title mb-0">52 JPG file Generated</p><small class="text-muted">FontEnd-->
<!--            Developer</small>-->
<!--          </div>-->
<!--        </div>-->
<!--        <small class="search-data-size mr-50 text-muted">&apos;11kb</small>-->
<!--      </a></li>-->
<!--      <li class="auto-suggestion"><a class="d-flex align-items-center justify-content-between w-100"-->
<!--                                     href="javascript:void(0)">-->
<!--        <div class="d-flex">-->
<!--          <div class="mr-75"><img src="app-assets/images/icons/pdf.png" alt="png" height="32"></div>-->
<!--          <div class="search-data">-->
<!--            <p class="search-data-title mb-0">25 PDF File Uploaded</p><small class="text-muted">Digital-->
<!--            Marketing-->
<!--            Manager</small>-->
<!--          </div>-->
<!--        </div>-->
<!--        <small class="search-data-size mr-50 text-muted">&apos;150kb</small>-->
<!--      </a></li>-->
<!--      <li class="auto-suggestion"><a class="d-flex align-items-center justify-content-between w-100"-->
<!--                                     href="javascript:void(0)">-->
<!--        <div class="d-flex">-->
<!--          <div class="mr-75"><img src="app-assets/images/icons/doc.png" alt="png" height="32"></div>-->
<!--          <div class="search-data">-->
<!--            <p class="search-data-title mb-0">Anna_Strong.doc</p><small class="text-muted">Web-->
<!--            Designer</small>-->
<!--          </div>-->
<!--        </div>-->
<!--        <small class="search-data-size mr-50 text-muted">&apos;256kb</small>-->
<!--      </a></li>-->
<!--      <li class="d-flex align-items-center"><a href="javascript:void(0);">-->
<!--        <h6 class="section-label mt-75 mb-0">Members</h6>-->
<!--      </a></li>-->
<!--      <li class="auto-suggestion"><a class="d-flex align-items-center justify-content-between py-50 w-100"-->
<!--                                     href="javascript:void(0)">-->
<!--        <div class="d-flex align-items-center">-->
<!--          <div class="avatar mr-75"><img src="app-assets/images/portrait/small/avatar-s-8.jpg"-->
<!--                                         alt="png"-->
<!--                                         height="32"></div>-->
<!--          <div class="search-data">-->
<!--            <p class="search-data-title mb-0">-->
<!--              {{-->
<!--                $store.getters.getLoggedInUser ? $store.getters.getLoggedInUser.first_name + ' ' + $store.getters.getLoggedInUser.last_name : ''-->
<!--              }}</p>-->
<!--            <small class="text-muted">UI designer</small>-->
<!--          </div>-->
<!--        </div>-->
<!--      </a></li>-->
<!--      <li class="auto-suggestion"><a class="d-flex align-items-center justify-content-between py-50 w-100"-->
<!--                                     href="javascript:void(0)">-->
<!--        <div class="d-flex align-items-center">-->
<!--          <div class="avatar mr-75"><img src="app-assets/images/portrait/small/avatar-s-1.jpg"-->
<!--                                         alt="png"-->
<!--                                         height="32"></div>-->
<!--          <div class="search-data">-->
<!--            <p class="search-data-title mb-0">Michal Clark</p><small class="text-muted">FontEnd-->
<!--            Developer</small>-->
<!--          </div>-->
<!--        </div>-->
<!--      </a></li>-->
<!--      <li class="auto-suggestion"><a class="d-flex align-items-center justify-content-between py-50 w-100"-->
<!--                                     href="javascript:void(0)">-->
<!--        <div class="d-flex align-items-center">-->
<!--          <div class="avatar mr-75"><img src="app-assets/images/portrait/small/avatar-s-14.jpg"-->
<!--                                         alt="png"-->
<!--                                         height="32"></div>-->
<!--          <div class="search-data">-->
<!--            <p class="search-data-title mb-0">Milena Gibson</p><small class="text-muted">Digital Marketing-->
<!--            Manager</small>-->
<!--          </div>-->
<!--        </div>-->
<!--      </a></li>-->
<!--      <li class="auto-suggestion"><a class="d-flex align-items-center justify-content-between py-50 w-100"-->
<!--                                     href="javascript:void(0)">-->
<!--        <div class="d-flex align-items-center">-->
<!--          <div class="avatar mr-75"><img src="app-assets/images/portrait/small/avatar-s-6.jpg"-->
<!--                                         alt="png"-->
<!--                                         height="32"></div>-->
<!--          <div class="search-data">-->
<!--            <p class="search-data-title mb-0">Anna Strong</p><small class="text-muted">Web Designer</small>-->
<!--          </div>-->
<!--        </div>-->
<!--      </a></li>-->
<!--    </ul>-->
<!--    <ul class="main-search-list-defaultlist-other-list d-none">-->
<!--      <li class="auto-suggestion justify-content-between"><a-->
<!--          class="d-flex align-items-center justify-content-between w-100 py-50">-->
<!--        <div class="d-flex justify-content-start"><span class="mr-75" data-feather="alert-circle"></span><span>No results found.</span>-->
<!--        </div>-->
<!--      </a></li>-->
<!--    </ul>-->
  </div>
  <Logout :show="showLogoutModal" @logout="logout"
          @hide="showLogoutModal = false"></Logout>

  <ApiKeyModal :show="showApiKeys" @hide="showApiKeys = false" />
</template>

<script>
import { mapState } from 'vuex'
import Button from "@/components/common/Button";
import ApiKeyModal from "@/components/common/ApiKeyModal";
export default {
  components: {Button,ApiKeyModal},
  computed: {
    ...mapState(['userProfilePicture'])
  },
  data() {
    return {
      selectdValet: null,
      valetData: [],
      showLogoutModal: false,
      hideBar: false,
      notiCount: this.notificationCount,
      notificationList: [],
      profileImage: this.publicPath+'images/avatar/avatar-user.png',
      keyUpdate:2,
      showApiKeys:false

    }
  },
  mounted() {
    if(this.userProfilePicture){
      this.profileImage = this.userProfilePicture
    }

    this.getValetData();
    this.emitter.on("notification-count", (data) => {
      this.notiCount = data
    });

    this.emitter.on("refreshWallet", (data) => {
      this.getValetData();
    });


  },
  methods: {
    resolveUserImage(){

      let userData = this.$store.getters.getLoggedInUser
      if(userData){
        if(userData.avatar){
          return this.profileImage = userData.avatar
        }
      }
      return this.profileImage

    },
    routeTo(type){
      if(type.toLowerCase() == 'transaction' ){
        document.querySelector("#noti-dropdown-li").classList.remove("show");
        document.querySelector("#noti-dropdown-ul").classList.remove("show");
        this.$router.push({name:'transactions'})

      }
      else{
        return null
      }
    },
    toggleSideBar() {
      this.hideBar = !this.hideBar
    },
    getNotifications() {
      this.makeRequest('post', 'v1/notifications', {}, {}, false).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let data = callResponse.response.data.data
            this.notificationList = data.data
          }
        }

      });

    },
    logout() {

      this.makeRequest('post', 'v1/logout-user', {}).then(callResponse => {

        if (!callResponse.error) {
          this.deleteAdminLoginCookie()
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.showLogoutModal = false
            localStorage.setItem('vault-pay-access-token', null);
            localStorage.clear();
            this.removeCookie('xbrowwser')
            this.$router.push({name: 'send-otp'});
          }
        }

      });

    },
    getValetData() {
      this.makeRequest("post", "v1/get-wallet-list", {}, {}, false,false).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                this.valetData = responseData;
                this.$store.commit("setAccountData", responseData);
                this.setSelectValetValue();
              }
            }
          }
      );
    },
    setSelectValetValue() {
      this.valetData.forEach((obj) => {
        // if (obj.is_default == 1) {
        //   this.selectdValet = obj;
        //   // this.currency = obj
        //   this.$store.commit("setCurrencyData", obj);
        //   this.emitter.emit("change-currency", obj);
        // }
      });
      // if (this.selectdValet == null && this.valetData.length > 0) {
      if (this.valetData.length > 0) {
        this.selectdValet = this.valetData[0];
        // this.currency = this.valetData[0]
        // this.$store.commit("setCurrencyData", this.valetData[0]);
        // this.emitter.emit("change-currency", this.valetData[0]);
      }
    },
  },
  watch: {
    selectdValet(val) {
      // this.$store.dispatch('fetchApi');
      // this.$store.dispatch("set", val);
      this.$store.dispatch('updateWalletAccount',val)
      // this.$store.commit("setAccountData", val);
      // this.emitter.emit("change-currency", val);
      // alert(val)
    },
    userProfilePicture(val){
      this.keyUpdate = Math.random()
      this.profileImage = localStorage.getItem('userProfilePicture')
    }
  },
}
</script>

